(function IIFE() {
    'use strict';

    /////////////////////////////

    function EventService(EventFactory, LumsitesBaseService) {
        'ngInject';

        return LumsitesBaseService.createLumsitesBaseService(EventFactory, {
            objectIdentifier: 'uid',
        });
    }

    /////////////////////////////

    angular.module('Services').service('EventService', EventService);
})();
